import React from 'react';
import { Headline, BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { IconArrowRight } from '@xingternal/icons';
export const FlagContent = ({ headerCopy, bodyCopy, ctaCopy, ctaUrl, premiumTheme, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Headline, { size: "medium", style: { color: 'initial' }, onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
            } }, headerCopy),
        bodyCopy.map((copy) => (React.createElement(BodyCopy, { onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
            }, key: copy, size: "small", style: { color: 'initial' } },
            React.createElement("span", { dangerouslySetInnerHTML: { __html: copy } })))),
        ctaCopy &&
            (premiumTheme ? (React.createElement(Button, { href: ctaUrl, variant: "premium", size: "small", iconAfter: true, icon: IconArrowRight, "data-testid": "user-flag-cta" }, ctaCopy)) : (React.createElement(Button, { href: ctaUrl, variant: "tertiary", size: "small", "data-testid": "user-flag-cta" }, ctaCopy)))));
};
//# sourceMappingURL=flag-content.js.map